var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.icon)?_c('img',{attrs:{"src":`${_vm.$coroot.base_path}static/img/tech-icons/${_vm.icon}.svg`,"alt":_vm.icon + ' icon',"title":_vm.icon,"onerror":"this.style.opacity='0'","height":_vm.size,"width":_vm.size}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }